<template>
  <div>
    <form class="gen-form" data-form="profile">
      <div class="gen-fieldset__item"><label>ID</label><input type="text" name="login" :value="Lead.info.login" disabled=""></div>
      <div class="gen-fieldset__item">
        <label>Brand</label>
        <div class="gen-select-container ">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="home" data-id="32172"
               data-task="home">
            <button class="ui-ddbtn"><span class="ui-ddbtnvalue" data-value="Fxbullion.com">
            <img src="/img/home/t_logo_Fxbullion.com.png">fxbullion.com</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i></button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Firstname</label>
        <input type="text" name="firstname" v-model="Lead.info.firstname">
      </div>
      <div class="gen-fieldset__item">
        <label>Lastname</label>
        <input type="text" name="lastname" v-model="Lead.info.lastname">
      </div>
      <div class="gen-fieldset__item">
        <label>Email</label>
        <input type="text" name="email" v-model="Lead.info.email">
      </div>
      <div class="gen-fieldset__item">
        <label>Country</label>
        <div class="gen-select-container ">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="country" data-id="32172"
               data-task="country">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue" data-value="">Ukraine</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Last call date</label>
        <input type="text" name="lastcalldate" v-model="Lead.info.lastcalldate">
      </div>
      <div class="gen-fieldset__item">
        <label>Number of calls</label>
        <input type="text" name="callnum" :value="Lead.info.callnum" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Registration time</label>
        <input type="text" name="createdtime" :value="Lead.info.createdtime" disabled="">
      </div>
      <div class="gen-fieldset__item"><label>Date</label>
        <input type="text" name="createddate" :value="Lead.info.createddate + Lead.info.createdtime" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Landing</label>
        <input type="text" name="landing" v-model="Lead.info.landing"></div>
      <div class="gen-fieldset__item">
        <label>Aff.id</label>
        <input type="text" name="affid" :value="Lead.info.affid" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Campaign id</label>
        <input type="text" name="campaignid" :value="Lead.info.campaignid" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Employee</label>
        <div class="gen-select-container ">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="assign" data-id="32172"
               data-task="assign">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue" data-value="2">No User</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Status</label>
        <div class="gen-select-container ">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="leadstatus" data-id="32172"
               data-task="leadstatus">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue" data-value="">Voicemail</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Comment</label>
        <input type="text" name="lastcomment" :value="Lead.info.lastcomment" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Last comment date</label>
        <input type="text" name="lastcommentdate" :value="Lead.info.lastcommentdate" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Sms ver.required</label><input type="text" name="smsverreq" :value="Lead.info.smsverreq" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Sms verified</label>
        <input type="text" name="smsver" :value="Lead.info.smsver" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Sms ver.land.</label>
        <input type="text" name="cifver" :value="Lead.info.cifver" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Lead ID</label>
        <input type="text" name="id" :value="Lead.info.id" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Type</label>
        <div class="gen-select-container ">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="ltype" data-id="32172"
               data-task="ltype">
            <button class="ui-ddbtn">
              <span class="ui-ddbtnvalue" data-value="">Depositor</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Dep.status</label>
        <div class="gen-select-container gen-select-border-0">
          <div class="ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0" data-name="depstatus" data-id="32172"
               data-task="depstatus">
            <button class="ui-ddbtn-view">
              <span class="ui-ddbtnvalue" data-value="">-</span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            <div class="ui-ddbody">
              <div class="ui-ddsection">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gen-fieldset__item">
        <label>Deposit status date</label>
        <input type="text" name="depsatusdd" :value="Lead.info.depsatusdd" disabled="">
      </div>
      <div class="gen-fieldset__item"><label>Has duplicated?</label>
        <input type="text" name="hasduplicates" value="Yes" disabled=""></div>
      <div class="gen-fieldset__item"><label>Online</label>
        <input type="text" name="online" value="1" disabled=""></div>
      <div class="gen-fieldset__item">
        <label>Last online time</label>
        <input type="text" name="lastlonline" :value="Lead.info.lastlonline" disabled="">
      </div>
      <div class="gen-fieldset__item">
        <label>Last offlime time</label>
        <input type="text" name="lastoffline" :value="Lead.info.lastoffline" disabled="">
      </div>
    </form>
    <div class="gen-form-post-btns">
      <button class="btn gen-form-post"><span>Update</span></button>
    </div>
  </div>
</template>

<script>
import {COUNTRIES} from '../../../static/countries'

export default {
  name: "ProfileTab",
  data() {
    return {
      countries: COUNTRIES
    }
  },
  computed: {
    Lead: {
      get() {
        return this.$store.state.leadData;
      },
      set(value) {
        this.$store.commit('setter', {leadData : value})
      }
    }
  },
  methods: {
    submit() {
      const info = this.Lead.info;
      const data = {
        id : info.id,
        userid : this.Lead.userid,
        firstname : info.firstname,
        lastname : info.lastname,
        email : info.email,
        lastcalldate : info.lastcalldate,
        landing : info.landing,
        home : info.home,
        country : info.country,
        assign : info.assign,
        leadstatus : info.leadstatus,
        ltype : info.ltype,
      }
    }
  }
}
</script>

<style scoped>

</style>
